// extracted by mini-css-extract-plugin
export default {"categories":"Sidebar_categories__DC4Kl","container":"Sidebar_container__w7Bux","scrollable-content":"Sidebar_scrollable-content__49Ybk"};